package pl.mothdigital.neuronowi.theme.palette

import com.varabyte.kobweb.compose.ui.graphics.*
import com.varabyte.kobweb.silk.theme.colors.*

object GrayPalette : ColorPalette {
    override val _50: Color.Rgb
        get() = Color.rgb(0xf9fafb)
    override val _100: Color.Rgb
        get() = Color.rgb(0xf3f4f6)
    override val _200: Color.Rgb
        get() = Color.rgb(0xe5e7eb)
    override val _300: Color.Rgb
        get() = Color.rgb(0xd1d5db)
    override val _400: Color.Rgb
        get() = Color.rgb(0x9ca3af)
    override val _500: Color.Rgb
        get() = Color.rgb(0x6b7280)
    override val _600: Color.Rgb
        get() = Color.rgb(0x4b5563)
    override val _700: Color.Rgb
        get() = Color.rgb(0x374151)
    override val _800: Color.Rgb
        get() = Color.rgb(0x1f2937)
    override val _900: Color.Rgb
        get() = Color.rgb(0x111827)
}
